import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { DatiPersonaliDTO } from "../dto/dati-personaliDTO";
import { DatiPersonaliVO } from "../vo/dati-personaliVO";
import { SiNoEnum } from "../enum/si-no-enum";

@Injectable({
  providedIn: "root",
})
export class MapperDatiPersonali
  implements MapperInterface<DatiPersonaliDTO, DatiPersonaliVO> {
  convertVoToDto(vo: DatiPersonaliVO): DatiPersonaliDTO {
    if (vo != null) {
      const dto = new DatiPersonaliDTO();
      // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
      dto.datiGiudiziari = vo.datiGiudiziari;

      dto.datiComuni = vo.datiComuni;

      dto.datiParticolari = vo.datiParticolari;

      dto.datiRiservati = vo.datiRiservati;

      dto.privato = vo.privato;

      dto.motivoRestrizioni = vo.motivoRestrizioni;

      if (vo.condizioniRiproduzione) {
        dto.condizioniRiproduzione = vo.condizioniRiproduzione;
      }

      if (vo.condizioniConsultabilita) {
        dto.condizioniConsultazione = vo.condizioniConsultabilita;
      }

      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: DatiPersonaliDTO): DatiPersonaliVO {
    if (dto != null) {
      const vo = new DatiPersonaliVO();
      // TODO fare mapper questa riga funge solo se DTO e VO sono identici
      // vo = JSON.parse(JSON.stringify(dto));
      if (dto.datiGiudiziari) {
        vo.datiGiudiziari = true;
      } else {
        vo.datiGiudiziari = false;
      }
      if (dto.datiComuni) {
        vo.datiComuni = true;
      } else {
        vo.datiComuni = false;
      }
      if (dto.datiParticolari) {
        vo.datiParticolari = true;
      } else {
        vo.datiParticolari = false;
      }
      if (dto.privato) {
        vo.privato = true;
      } else {
        vo.privato = false;
      }
      vo.datiRiservati = dto.datiRiservati;
      vo.motivoRestrizioni = dto.motivoRestrizioni;

      if (dto.condizioniRiproduzione) {
        vo.condizioniRiproduzione = dto.condizioniRiproduzione;
      }

      if (dto.condizioniConsultazione) {
        vo.condizioniConsultabilita = dto.condizioniConsultazione;
      }

      return vo;
    } else {
      return null;
    }
  }

  convertListVoToDto(voList: DatiPersonaliVO[]): DatiPersonaliDTO[] {
    if (voList != null) {
      return voList.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }

  convertListDtoToVo(dtoList: DatiPersonaliDTO[]): DatiPersonaliVO[] {
    if (dtoList != null) {
      return dtoList.map((dto) => this.convertDtoToVo(dto));
    } else {
      return null;
    }
  }
}
